export default {
  downloadUrl: "https://cdn.matrixgames.fun/apk/MatrixGame.apk"
}


//////////////////
// WEBPACK FOOTER
// ./urlConfig.js
// module id = null
// module chunks = 